export const LEAGUE_OPTIONS = [
    {
        value: "1OU5304zvw151RitjYjcjvIWyTHVAg6p7G8RNlbEKnZY",
        label: "GT3X",
    },
    {
        value: "1SEIDnbr6YjyJRWMME9QwdsdjBhY4IR0sHjCLw0l0tm0",
        label: "RaceVision Test",
    },
];

export const LEAGUE_OPTIONS_SINGLE_CLASS = [
    {
        value: "1bdWoKQm-B96F6fGmeB7Lo0BAiKDglXsQboXaVdtkIZI",
        label: "SpecialX",
    },
    {
        value: "1SEIDnbr6YjyJRWMME9QwdsdjBhY4IR0sHjCLw0l0tm0",
        label: "RaceVision Test",
    },
];